<template>
    <div class="board">
        <div>
            <img src="@/assets/img/atc.svg" usemap="#image-map">

            <map name="image-map">
                <area v-for="link in links" :key="link.href" target="_self" :alt="link.alt" :title="link.title" :href="link.href" :coords="link.coords" shape="rect">
            </map>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AccountThinkBanner",
        props: ['companyId'],
        data() {
            return { 
                links: [
                    {alt: '', title: '', href: `/journal-and-gl?companyId=${this.$route.query.companyId}&tab=sales`, coords: '37,174,254,196'},
                    {alt: '', title: '', href: `/general-ledger?companyId=${this.$route.query.companyId}`, coords: '38,198,254,219'},
                    {alt: '', title: '', href: `/expenses?companyId=${this.$route.query.companyId}`, coords: '35,332,257,354'},
                    {alt: '', title: '', href: `/taxation-sales?companyId=${this.$route.query.companyId}`, coords: '34,545,256,567'},
                    {alt: '', title: '', href: `/journal-and-gl?companyId=${this.$route.query.companyId}&tab=sales`, coords: '1054,304,1221,326'},
                    {alt: '', title: '', href: `/journal-and-gl?companyId=${this.$route.query.companyId}&tab=cashReceipts`, coords: '1056,341,1223,358'},
                    {alt: '', title: '', href: `/journal-and-gl?companyId=${this.$route.query.companyId}&tab=cashDisbursements`, coords: '1055,362,1222,375'},
                    {alt: '', title: '', href: `/journal-and-gl?companyId=${this.$route.query.companyId}&tab=general`, coords: '1057,410,1224,429'},
                    {alt: '', title: '', href: `/finance-bank-accounts?companyId=${this.$route.query.companyId}`, coords: '1384,217,1580,236'},
                    {alt: '', title: '', href: `/reconciliation?companyId=${this.$route.query.companyId}`, coords: '1384,305,1580,324'},
                    {alt: '', title: '', href: `/cash-receipts?companyId=${this.$route.query.companyId}`, coords: '1383,327,1579,346'},
                    {alt: '', title: '', href: `/settings-worksheet?companyId=${this.$route.query.companyId}`, coords: '693,19,849,52'},
                    {alt: '', title: '', href: `/general-ledger?companyId=${this.$route.query.companyId}`, coords: '1059,524,1222,562'},
                ]
            }
        },
    }
</script>

<style lang="less" scoped>
.board {
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
}
// .image-banner {
//     width: 100%;
// }
</style>
